import {
    Box,
    Dialog,
    DialogContent,
    DialogTitle,
    Divider,
    IconButton,
    Typography,
    useTheme,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { ScoringScoreBadge } from './ScoringScoreBadge';
import { ScoringResultItem } from '../types';
import ScoringExplainerContent from './ScoringExplainerContent';

interface ScoringExplainerModalProps {
    open: boolean;
    onClose: () => void;
    result: ScoringResultItem | null;
    talentLabel?: string;
    jobOfferLabel?: string;
}

export const ScoringExplainerModal = ({
    open,
    onClose,
    result,
    talentLabel,
    jobOfferLabel,
}: ScoringExplainerModalProps) => {
    const theme = useTheme();

    if (!result) return null;

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    pr: 1,
                }}
            >
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                    <Typography variant="h6" component="span">
                        Score de compatibilité
                    </Typography>
                    {(talentLabel || jobOfferLabel) && (
                        <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>
                            {[talentLabel, jobOfferLabel].filter(Boolean).join(' × ')}
                        </Typography>
                    )}
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <ScoringScoreBadge score={result.score} status={result.status} />
                    <IconButton onClick={onClose} size="small">
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </Box>
            </DialogTitle>
            <Divider />
            <DialogContent>
                {result.explainer ? (
                    <ScoringExplainerContent html={result.explainer} score={result.score} />
                ) : (
                    <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>
                        Aucune explication disponible.
                    </Typography>
                )}
            </DialogContent>
        </Dialog>
    );
};

export default ScoringExplainerModal;
